import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SceneSelector from './SceneSelector'
import ViewImage from './ViewImage'
import { batchUpdateCalculatorAction, updateCalculatorAction } from 'actions/calculatorActions'
import { changeCameraModelAction } from 'actions/cameraActions'
import { checkOfflineLimitsAction } from 'actions/applicationActions'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import sceneUrl from 'helpers/fovPreview/sceneUrl'
import { CONVENTIONAL, CORRIDOR } from 'helpers/globals'
import equals from 'ramda/src/equals'

function mapStateToProps({ cameras, presentationValues, cameraModels }) {
  return {
    currentCamera: getCurrentCamera(cameras),
    presentationValues,
    cameraModels
  }
}

class SimulatedView extends React.Component {
  state = { showScenes: false }

  componentDidUpdate(prevProps) {
    if (prevProps.currentCamera && this.props.currentCamera && equals(prevProps.currentCamera.id, this.props.currentCamera.id) &&
      !equals(prevProps.currentCamera.userUploadedSceneUrl, this.props.currentCamera.userUploadedSceneUrl)) {
      this.setState({ showScenes: false })
    }
  }

  toggleShow = _ =>
    this.setState({ showScenes: !this.state.showScenes })

  updateScene = sceneName => {
    this.props.batchUpdateCalculatorAction({ streetViewActive: false, userUploadedSceneActive: false, userSelectedGeneralScene: true, sceneName },
      ['streetViewActive', 'userUploadedSceneActive', 'userSelectedGeneralScene', 'sceneName'], this.props.currentCamera.id, false)
    this.toggleShow()
  }

  setCustomScene = _ => {
    const { batchUpdateCalculatorAction, currentCamera: { userUploadedSceneUrl, id } } = this.props
    batchUpdateCalculatorAction({ userUploadedSceneUrl, userUploadedSceneActive: true }, [ 'userUploadedSceneUrl', 'userUploadedSceneActive' ], id, false)
    this.toggleShow()
  }

  setStreetView = _ => {
    this.props.batchUpdateCalculatorAction({ streetViewActive: true, userUploadedSceneActive: false, userSelectedGeneralScene: false },
      ['streetViewActive', 'userUploadedSceneActive', 'userSelectedGeneralScene'], this.props.currentCamera.id, false)
    this.toggleShow()
  }

  render() {
    const { toggleShow, updateScene, setCustomScene, setStreetView, state: { showScenes }, props: { currentCamera, presentationValues: { angleOfView },
      batchUpdateCalculatorAction, updateCalculatorAction, checkOfflineLimitsAction, close, classes, cameraModels, changeCameraModelAction } } = this
    const aov_modes = [180, 360]
    if (!currentCamera) return null

    const { streetViewAvailable, streetViewActive, userUploadedSceneUrl, id, fovMode, model, horizontalAngleOfView } = currentCamera
    if (showScenes) {
      return (
        <div className={classes.simulatedView}>
          <div className={classes.topBar}>
            { streetViewAvailable &&
              <div className={classes.topButton} onClick={setStreetView}>
                Street View
              </div>
            }
            <div className={classes.topButton} onClick={_ => checkOfflineLimitsAction('modal', ['FovUploadsForm'])}>
              { userUploadedSceneUrl ? 'Re-Upload Scene' : 'Upload Scene' }
            </div>
          </div>
          <SceneSelector { ...{ currentScene: sceneUrl(currentCamera), currentCamera, updateScene, setCustomScene } } />
          <div className={classes.saveButton} onClick={toggleShow}>
            Save
          </div>
        </div>
      )
    }

    return (
      <div className={classes.simulatedView}>
        <div className={classes.topBar}>
          <div style={{ flex: 1 }} />
          <span>AoV: { angleOfView.value }°</span>
          { model && model.is_fisheye
            ? <div className={classes.fovButtonContainer}>
                { aov_modes.map((mode, i) =>
                    <div
                      className={horizontalAngleOfView === mode ? classes.fovButtonActive : classes.fovButton}
                      onClick={_ => horizontalAngleOfView === aov_modes[1 - i] && changeCameraModelAction(cameraModels.find(m => m.id === model.id), model.other_fisheye_aov)}
                      key={i}
                    >
                      {aov_modes[i]}
                    </div>
                  )
                }
              </div>
            : <div className={classes.fovButtonContainer}>
                <div
                  className={fovMode === CONVENTIONAL ? classes.fovButtonActive : classes.fovButton}
                  onClick={_ => fovMode !== CONVENTIONAL && updateCalculatorAction(CONVENTIONAL, 'fovMode', id, false)}
                >
                  <FontAwesomeIcon icon={['far', 'image']} />
                </div>
                <div
                  className={fovMode === CORRIDOR ? classes.fovButtonActive : classes.fovButton}
                  onClick={_ => fovMode !== CORRIDOR && updateCalculatorAction(CORRIDOR, 'fovMode', id, false)}
                >
                  <FontAwesomeIcon icon={['far', 'image']} rotation={90} />
                </div>
              </div>
          }
        </div>
        <ViewImage { ...{ ...currentCamera, scene: sceneUrl(currentCamera), batchUpdateCalculatorAction, streetViewActive } } />
        <div className={classes.bottomRow}>
          <div className={classes.backButton} onClick={close}>
            <FontAwesomeIcon icon='chevron-left' className={classes.backIcon} />
            Back
          </div>
          <div className={classes.changeButton} onClick={toggleShow}>
            Change Scene
          </div>
          <div style={{ flex: 1 }} />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { batchUpdateCalculatorAction, updateCalculatorAction, checkOfflineLimitsAction, changeCameraModelAction })(injectSheet(style)(SimulatedView))



// WEBPACK FOOTER //
// ./src/components/BottomBar/SimulatedView/index.js